import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "album",
  "use": "album-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"album\"><title>_album</title><g id=\"album_album\"><circle cx=\"22\" cy=\"20.5446\" r=\"3\" /><path d=\"M35.4034,2.28,9.5724.02A5.0374,5.0374,0,0,0,4.1183,4.5974L3.465,12.0579A4.0377,4.0377,0,0,0,0,16.0355v19.929A4.0474,4.0474,0,0,0,4.0355,40h25.929A4.0473,4.0473,0,0,0,34,35.9645V32.112a5.0333,5.0333,0,0,0,4.2443-4.524L39.9806,7.735A5.0407,5.0407,0,0,0,35.4034,2.28ZM4.0355,14h25.929A2.0378,2.0378,0,0,1,32,16.0355v8.4526L20.6074,31.5537l-8.36-7.2671a1.9967,1.9967,0,0,0-2.4746-.08L2,29.9341V16.0355A2.0378,2.0378,0,0,1,4.0355,14Zm25.929,24H4.0355A2.0378,2.0378,0,0,1,2,35.9645V32.2236l.0928.126,8.8545-6.5425,8.3593,7.2661a1.9972,1.9972,0,0,0,1.2881.47,2.0364,2.0364,0,0,0,1.0469-.291L32,26.84v9.125A2.0378,2.0378,0,0,1,29.9645,38Zm6.2876-10.5858A3.019,3.019,0,0,1,34,30.0733V16.0355A4.0473,4.0473,0,0,0,29.9645,12H5.4775l.633-7.2283A3.0269,3.0269,0,0,1,9.3986,2.0124l25.831,2.26a3.0392,3.0392,0,0,1,2.7588,3.289Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/album.svg
// module id = CpTG
// module chunks = 4